@for (part of highlight(); track $index) {
    @if (typeof part === "string") {
        <span>{{ part }}</span>
    } @else if (part !== null && typeof part === "object") {
        <span class="match-segment">{{ part.match }}</span>
    }
}
